module.exports = __webpack_public_path__ + "static/media/20201216_202405_050_IMG_3205.774b8328.jpg";